export default function RequireVerifiedDocs({ children }) {
  // Account-level pending-approval gating is intentionally disabled for care pricing.
  return children;
}
